import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserRole } from '@p2p/users/domain';

import * as AccessControlActions from './access-control.actions';
import * as AccessControlSelectors from './access-control.selectors';

@Injectable()
export class AccessControlFacade {
    private readonly store = inject(Store);

    permissions$ = this.store.select(AccessControlSelectors.selectPermissions);

    loadPermissions(role: UserRole): void {
        this.store.dispatch(AccessControlActions.loadPermissions({ role }));
    }
}
